import { atom } from "recoil";

export const SelectedTagsAtom = atom<string[]>({
  key: "SelectedTagsAtom",
  default: [],
});

export const SelectedTagsBatchDeleteAtom = atom<string[]>({
  key: "SelectedTagsBatchDeleteAtom",
  default: [],
});
